<tds-header class="tds-u-flex tds-u-align-center">
  <tds-header-hamburger
    (click)="mobileMenuAction()"
    aria-expanded="false"
    aria-haspopup="true"
  ></tds-header-hamburger>
  <tds-header-title>CONTROL CENTER</tds-header-title>

  <app-select
    class="global-selector"
    label="Local"
    [options]="ddlLocais"
    [(ngModel)]="selectedLocalId"
    (ngModelChange)="onLocalChange($event)"
  >
  </app-select>

  <tds-header-brand-symbol slot="end">
    <a aria-label="Scania - red gryphon on blue shield"></a>
  </tds-header-brand-symbol>
</tds-header>
